module.exports = __webpack_public_path__ + "media/images/application/icons/arrow-select-white-ee399c19ab929a7e471d4963641980a5.svg";